import Modal from "../Modals"
import Table from "../custom/Table"
import { TColumn } from "../../Models/common"
import useService from "../../hooks/useService"
import { TRANSACTION_TYPES } from "../../utils/constant"
import { useEffect, useState } from "react"

export type TBillingDetailsItem = {
    id: any
    name: string
    unitPrice?: any
    quantity?: any
    SGST_UTGST?: any
    CGST?: any
    IGST?: any
    preTaxAmount?: any
    totalAmount: any
}

type TBillingDetailsModalProps = {
    onClose: Function,
    open: boolean,
    lineItems: TBillingDetailsItem[]
}

const columns: TColumn<TBillingDetailsItem>[] = [
    {
        field: 'name',
        headerName: 'Item',
        minWidth: window.innerWidth > 900 ? 300 : 200
    },
    {
        field: 'quantity',
        headerName: 'Quantity'
    },
    {
        field: 'unitPrice',
        headerName: 'Unit Price (Rs)',
        minWidth: 150
    },
    {
        field: 'SGST_UTGST',
        headerName: 'SGST_UTGST (%)'
    },
    {
        field: 'CGST',
        headerName: 'CGST (%)'
    },
    {
        field: 'IGST',
        headerName: 'IGST (%)'
    },
    {
        field: 'preTaxAmount',
        headerName: 'Taxable Amount (Rs)',
        minWidth: 150
    },
    {
        field: 'totalAmount',
        headerName: 'Total Amount (Rs)',
        minWidth: 150
    },
]

const BillingDetailsModal = (props: TBillingDetailsModalProps) => {
    const { store } = useService()
    const { transactionInfo } = store.transactionsStore
    const { lineItems, onClose, open } = props
    const [BillingDetailsColumns, setBillingDetailsColumns] = useState<any[]>([]);
    
    useEffect(() => {
        let lineItemsCopy = (lineItems && lineItems.length) ? [...lineItems] : [];
        if(lineItemsCopy && lineItemsCopy.length){
            let igstCheck = lineItems.find(obj => obj.name.includes('IGST'));
            let CgstCheck = lineItems.find(obj => obj.name.includes('CGST'));

            if(igstCheck){
                for(let i = 0 ; i < lineItemsCopy?.length ; i++){
                    if(lineItemsCopy[i]?.preTaxAmount  && lineItemsCopy[i]?.preTaxAmount != '0')
                    lineItemsCopy[i].IGST = 3
                    if(lineItemsCopy[i].name == "IGST")
                        lineItemsCopy[i].IGST = ''
                }
            }

            if(CgstCheck){
                for(let i = 0 ; i < lineItemsCopy?.length ; i++){
                    if(lineItemsCopy[i]?.preTaxAmount  && lineItemsCopy[i]?.preTaxAmount != '0'){
                            lineItemsCopy[i].CGST = 1.5
                            lineItemsCopy[i].SGST_UTGST = 1.5
                        }
                        if(lineItemsCopy[i].name == "CGST")
                            lineItemsCopy[i].CGST = ''
                    }
                }

        }
        setBillingDetailsColumns(lineItemsCopy)
    }, [lineItems])
       
    return <Modal
        onClose={onClose}
        open={open}
        title="Billing Details"
        fullwidth
        maxWidth='md'
    >
        <Table
            columns={transactionInfo.transactionType === TRANSACTION_TYPES.BUY_SELL ? columns.map(column => {
                return column.field === 'quantity' ? { ...column, headerName: 'Quantity (gm)' } : column
            }) :
                columns}
            rows={[...BillingDetailsColumns]}
            // initialState={{ sorting: { sortModel: [{ field: 'name', sort: 'asc' }] } }}
        />
    </Modal>
}

export default BillingDetailsModal